var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingGhost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lds-spookyghost",
    width: "200px",
    height: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50 -50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(257.983 50 50)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-2 50 50;359 50 50",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 39.891,
    stroke: "#d8ebf9",
    strokeWidth: 14.4,
    fill: "none",
    strokeDasharray: "0 300"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "10 300;60.15421082128821 300;4 300",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "linear",
    keySplines: "0 1 1 0;0 1 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 39.891,
    stroke: "#d8ebf9",
    strokeWidth: 7.2,
    fill: "none",
    strokeDasharray: "0 300"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "10 300;60.15421082128821 300;4 300",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "linear",
    keySplines: "0 1 1 0;0 1 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 32.771,
    stroke: "#1d3f72",
    strokeWidth: 1,
    fill: "none",
    strokeDasharray: "0 300"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "10 300;49.41750376837973 300;4 300",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "linear",
    keySplines: "0 1 1 0;0 1 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 47.171,
    stroke: "#1d3f72",
    strokeWidth: 1,
    fill: "none",
    strokeDasharray: "0 300"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "10 300;72.03697087422624 300;4 300",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "linear",
    keySplines: "0 1 1 0;0 1 1 0"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(100.738 50 50)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "360 50 50;0 50 50",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8ebf9",
    stroke: "#1d3f72",
    d: "M82.8,50c0,0.9,0.7,2.6,1.8,3.7c0.3,0.3,0.8,0.6,1,1c0.2,0.5,0.2,1-0.1,1.5c-0.3,0.5-0.8,0.9-1.1,1.3 c-0.5,0.5-0.8,1.1-0.9,1.7c-0.2,0.6-0.2,1.2,0.2,1.8c0.6,1,2,1.7,2,2.8c-0.1,0.9-1,1.5-1.4,2.2c-0.3,0.6-0.4,1.2-0.2,1.9 c0.2,0.7,0.5,1.3,1,1.8c1,1,2.4,1.4,3.9,1.5c-1.1-1-1.2-2.7-0.5-4c0.7-1.2,2.2-1.9,2.5-3.3c0.2-1.2-0.4-2.5,0.1-3.6 c0.7-1.5,3.3-1.3,4.1-2.9c0.3-0.9,0-1.9,0.3-2.8c0.2-0.7,0.6-1.1,1-1.5c0.4-0.4,0.8-0.9,0.9-1.6c0.1-0.5,0.1-0.9,0.1-1.6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(49.9331 50 50)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "360 50 50;0 50 50",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1",
    begin: "-0.1s"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8ebf9",
    stroke: "#1d3f72",
    d: "M82.8,50c-0.1-3.1-0.4-6.2-1.3-9.2c-0.1-0.4-0.2-0.8-0.2-1.2c-0.1-0.4-0.1-0.8,0-1.2c0.1-0.8,0.3-1.6,0.7-2.4 c0.8-1.5,2-3,3.8-3.9l0,0c1.8-0.9,3.8-1,5.6-0.2c0.9,0.4,1.7,1,2.4,1.8c0.3,0.4,0.7,0.8,1,1.3c0.2,0.5,0.4,1,0.6,1.6 c1.4,4.3,1.9,8.8,1.9,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#71c2cc",
    d: "M93.6,35.5c0.1,0.4-0.3,0.8-1,1c-0.6,0.2-1.2,0.1-1.3-0.3c-0.1-0.3,0.3-0.8,0.9-1S93.5,35.1,93.6,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#71c2cc",
    d: "M82.3,39.3c0.1,0.3,0.6,0.3,1.3,0.1c0.6-0.2,1.1-0.6,1-0.9c-0.1-0.3-0.7-0.3-1.3-0.1 C82.6,38.6,82.2,39,82.3,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d3f72",
    d: "M88.9,37.5c0.1,0.3-0.2,0.7-0.7,0.8c-0.5,0.1-0.9,0-1-0.3c-0.1-0.3,0.2-0.7,0.7-0.8C88.4,37,88.9,37.2,88.9,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1d3f72",
    d: "M86.2,39.6c0.2,0.6,0.8,0.9,1.4,0.7c0.6-0.2,0.9-0.9,0.6-2.1c0.3,1.2,1,1.7,1.6,1.5c0.6-0.2,1-0.8,0.8-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8ebf9",
    stroke: "#1d3f72",
    d: "M82.5,45.9c0,0.5,0.1,0.9,0.5,1.3c0.4,0.4,1,0.6,1.6,0.3c0.3-0.1,0.5-0.3,0.7-0.4c0.5-0.2,1.2,0.1,1.5,0.6 c0.3,0.5,0.3,1,0.3,1.6c0.6-0.6,1-1.4,1.3-2.2c0.2-0.7,0.4-1.5,0.2-2.2c-0.2-0.7-0.8-1.3-1.5-1.5c-0.9-0.2-1.8,0.2-2.5,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8ebf9",
    stroke: "#1d3f72",
    d: "M96.8,44.1c0.1,0.7,0.1,1.4-0.2,2c-0.3,0.6-0.9,1-1.5,0.7c-0.3-0.1-0.5-0.4-0.8-0.4c-0.6-0.2-1.2,0.3-1.4,0.9 c-0.2,0.6-0.1,1.2-0.1,1.9c-0.6-0.7-1.2-1.5-1.6-2.3c-0.4-0.7-0.6-1.5-0.6-2.2c0-0.8,0.3-1.6,0.9-2c0.7-0.5,1.7-0.5,2.6-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5699d2",
    d: "M85.3,37.2c0.1,0.3,1.2,0.2,2.5-0.3c1.3-0.4,2.2-1.1,2.1-1.4c-0.1-0.3-1.2-0.2-2.5,0.3 C86.1,36.3,85.2,36.9,85.3,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d3f72",
    d: "M91.5,35c0.3,0.7,0,1.4-0.7,1.6c-0.6,0.2-1.3-0.1-1.6-0.8c-0.2-0.6,0.1-1.3,0.7-1.6C90.6,33.9,91.3,34.3,91.5,35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d3f72",
    d: "M85.9,37c0.2,0.6-0.1,1.2-0.7,1.4c-0.6,0.2-1.3-0.1-1.5-0.6c-0.2-0.5,0.1-1.2,0.7-1.4C85,36.2,85.7,36.4,85.9,37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1d3f72",
    d: "M89.7,29c0.4,0.7-1.4,2.2-3.8,3.4c-2.5,1.2-4.7,1.7-4.9,1.2c-0.3-0.5,1.4-2,3.8-3.4S89.4,28.4,89.7,29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingGhost);
export default __webpack_public_path__ + "static/media/loading-ghost.beb1c41e2cd0db30375b9dec7bf54c4a.svg";
export { ForwardRef as ReactComponent };